import styled from 'styled-components'

export const CloseIconWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 5px;
`
export const Container = styled.div`
  padding: 10px;
`
export const Title = styled.div`
`
export const Controls = styled.div`
  display: flex;
  justify-content: flex-end;
`
